import InformationContainer from "./InformationContainer";

export default InformationContainer;